import { css, stack } from '@bts-web/utils-style-engine';

export const wrapperStyles = css({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  background: 'screen_background.primary',
});

export const headerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  padding: 'medium',
});

export const titleStyles = css({
  fontSize: 'headline.large_semi_bold',
  fontWeight: 'headline.large_semi_bold',
  letterSpacing: 'headline.large_semi_bold',
  lineHeight: 'headline.large_semi_bold',
  color: 'neutrals.text_primary',
  textAlign: 'center',
});

export const descriptionStyles = css({
  fontSize: 'body.medium',
  fontWeight: 'body.medium',
  letterSpacing: 'body.medium',
  lineHeight: 'body.medium',
  color: 'neutrals.text_primary',
  textAlign: 'center',
  paddingInline: 'medium',
});

export const contentStyles = stack({
  direction: 'column',
  flex: '1',
  overflow: 'auto',
  gap: 'extra_small_2',
  paddingInline: 'medium',
});

export const featureCardStyles = css({
  display: 'flex',
  gap: 'extra_small',
  padding: 'medium',
  background: 'neutrals.card_fill_primary',
  border: '1px solid',
  borderColor: 'neutrals.stroke_secondary',
  borderRadius: '16px',
  alignItems: 'center',
});

export const cardIconStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '24px',
  height: '24px',
});

export const cardContentStyles = stack({
  direction: 'column',
  gap: 'extra_small_3',
  flex: 1,
});

export const cardTitleStyles = css({
  fontSize: 'body.medium_medium',
  fontWeight: 'body.medium_medium',
  letterSpacing: 'body.medium_medium',
  lineHeight: 'body.medium_medium',
  color: 'neutrals.text_primary',
});

export const cardDescriptionStyles = css({
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  color: 'neutrals.text_secondary',
});

export const bottomSectionStyles = stack({
  direction: 'column',
  gap: 'medium',
  padding: 'medium',
});

export const checkboxContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
});
